import React, { HTMLAttributes, ReactNode } from 'react';

import { Tooltip } from 'antd';
import * as S from './styles';

interface IFloatingButton extends HTMLAttributes<HTMLElement> {
  title: string;
  icon: ReactNode;
}

const FloatingButton = ({ title, icon, ...rest }: IFloatingButton) => (
  <Tooltip title={title}>
    <S.ButtonContainer type="primary" size="large" icon={icon} {...rest} />
  </Tooltip>
);

export default FloatingButton;
